import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: 'paginator.template.html',
})
export class PaginatorComponent implements OnChanges {
  @Output() changePage: EventEmitter<number> = new EventEmitter();
  @Input() page: number;
  @Input() totalPages: number;
  @Input() boundaryCount: number;
  public lastPage: boolean;
  public showLastsDots: boolean;
  public showFirstDots: boolean;
  public pageNumbers: number[];
  public firstPage: boolean;
  public isMobile: boolean;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.page || changes.totalPages || changes.boundaryCount) {
      this.pageNumbers = this.getPageNumbers();
    }

    this.firstPage = !this.pageNumbers.find((page) => page === 1);

    this.lastPage = !this.pageNumbers.find((page) => page === this.totalPages);

    this.showLastsDots = !this.pageNumbers.includes(this.totalPages - 1);
    this.showFirstDots = !this.pageNumbers.includes(2);
  }

  nextPage() {
    if (this.page < this.totalPages) {
      this.emitChangePage(this.page + 1);
    }
  }

  previousPage() {
    if (this.page > 1) {
      this.emitChangePage(this.page - 1);
    }
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.emitChangePage(page);
    }
  }

  emitChangePage(page: number) {
    this.changePage.emit(page);
  }

  getPageNumbers() {
    const pageDiff = Math.floor(this.boundaryCount / 2);
    const startPage = Math.max(this.page - pageDiff, 1);
    const endPage = Math.min(
      startPage + this.boundaryCount - 1,
      this.totalPages,
    );

    return Array(endPage - startPage + 1)
      .fill(0)
      .map((_, index) => startPage + index);
  }
}
